<template>
    <div class="ContentBox">
        <div class="commonBox TopsBlack"> <Tops :ishome="false"/></div>
        <el-carousel class="bannerBox"  trigger="click" indicator-position="outside" >
            <el-carousel-item v-for="item in 1" :key="item">
             <img src="@/assets/banner-2.png" />
            </el-carousel-item>
        </el-carousel>
        <!--  -->
        <PathBox />
        <!--  -->
        <div class="ConetBox commonBox">
            <p>四川万象坤信科技有限公司专业从事数据库及信息技术开发，是唯一在大西部地区致力于政府机构行政执法大数据综合信息整合传输的高新技术企业和软件企业。公司自主研发了司法考试模考系统、公安机关人民警察执法资格考试系统、执法教育培训考试平台系统、行政执法监督平台、司法智能法律咨询服务支持平台、检察智能法律咨询服务支持平台等围绕依法行政、为政府单位提供法律数据支持系列产品。</p>
            <p>公司秉承“坚持、承当、奉献、包容”的经营理念，为用户提供专业的、量身定制的数据资源服务。目前西南各省区的，如四川、重庆、贵州、云南、宁夏、甘肃和广西的政府单位、政法系统、院校、金融机构等单位，已于近几年先后使用我公司提供的产品与服务。公司提供的信息在资源和功能上全面领先，在西南取得绝对优势的市场占有率，受到用户的一致好评。</p>
            <img src="@/assets/about_1.png" />
        </div>
        <Footer />
    </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
export default {
    components:{
        Tops,Footer,PathBox
    },
    data() {
      return {
        currentPage1: 5,
        MenuAct:'',
        CurrInt:'',
               activities: [{
          content: '活动按期开始',
          timestamp: '2018-04-15'
        }, {
          content: '通过审核',
          timestamp: '2018-04-13'
        }, {
          content: '创建成功',
          timestamp: '2018-04-11'
        }]
      }
    },
    methods:{   
      LookInfo(n){
        this.$router.push('/ListArtInfo?id='+n);
      },
      LookNavList(n){
        this.CurrInt = n;
      },
      ChangeNavMenu(n){
        this.MenuAct= n;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    }
}
</script>
<style lang="scss">
.el-timeline{
  padding: 0;
}
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  // ConetBox
  .ConetBox{
    p{
      text-indent: 40px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }
    img{
      width: 100%;
    }
  }
</style>